import { File, FilePdf, FileDoc, FilePpt } from '@phosphor-icons/react';
import { DocumentMimeType } from '@monorepo/shared';

interface DocumentFileIconProps {
  mimeType: string | null;
  size?: number;
}

export const DocumentFileIcon = ({ mimeType, size = 20 }: DocumentFileIconProps) => {
  if (mimeType === DocumentMimeType.PDF) {
    return <FilePdf size={size} className="text-red-500" />;
  }
  if (mimeType === DocumentMimeType.WORD) {
    return <FileDoc size={size} className="text-blue-500" />;
  }
  if (mimeType === DocumentMimeType.POWERPOINT) {
    return <FilePpt size={size} className="text-orange-500" />;
  }
  return <File size={size} className="text-gray-500" />;
};
